import { render } from "./ApplyAfterSales.vue?vue&type=template&id=4c612e9a&scoped=true"
import script from "./ApplyAfterSales.vue?vue&type=script&lang=js"
export * from "./ApplyAfterSales.vue?vue&type=script&lang=js"

import "./ApplyAfterSales.vue?vue&type=style&index=0&id=4c612e9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c612e9a"],['__file',"src/views/AfterSales/components/ApplyAfterSales.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c612e9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c612e9a', __exports__)) {
    api.reload('4c612e9a', __exports__)
  }
  
  module.hot.accept("./ApplyAfterSales.vue?vue&type=template&id=4c612e9a&scoped=true", () => {
    api.rerender('4c612e9a', render)
  })

}


export default __exports__